import React, { useCallback, useMemo } from 'react';
import { indexBy, prop } from 'ramda';
import { StyledColumnSettings, ResetButton, StyledColumnDndListWrap } from './styled';
import { useColumnsList } from './hooks';
import { Divider } from '../../../divider';
import { ColumnSettingsDndList } from './column-settings-dnd-list';
import { resetToDefaultHendler } from './helpers';
function defaultRequiredPredicate(column) {
    return !(column === null || column === void 0 ? void 0 : column.hidden);
}
// TODO: https://gitlab.apptrium.io/invent/frontend/wl-ui-kit/-/merge_requests/322
export const ColumnSettings = ({ columns, subColumns, hiddenColumns, hiddenSubColumns, columnOrder, subColumnOrder, limit, setColumnOrder, setSubColumnOrder, setHiddenColumns, setHiddenSubColumns, needCompareByColumnName = true, needUnselectedDown = true, requiredPredicate = defaultRequiredPredicate, requiredSubPredicate = defaultRequiredPredicate, defaultColumnsData, defaultSubColumnsData, tooltipStyle }) => {
    const hasSubColumnsList = subColumns && subColumns.length;
    const { orderedColumnIds } = useColumnsList(columns, columnOrder);
    const { orderedColumnIds: orderedSubColumnIds } = useColumnsList(subColumns || [], subColumnOrder || []);
    const subColumnsMap = useMemo(() => indexBy(prop('id'), subColumns || []), [subColumns]);
    const defaultSubColumnsMap = useMemo(() => indexBy(prop('name'), (defaultSubColumnsData || []).map((el, index) => ({ ...el, index }))), [defaultSubColumnsData]);
    const columnsMap = useMemo(() => indexBy(prop('id'), columns), [columns]);
    const defaultColumnsMap = useMemo(() => indexBy(prop('name'), (defaultColumnsData || []).map((el, index) => ({ ...el, index }))), [defaultColumnsData]);
    const handleResetToDefault = useCallback(() => {
        resetToDefaultHendler({
            orderedColumnIds,
            columnsMap,
            requiredPredicate,
            needCompareByColumnName,
            defaultColumnsMap,
            setColumnOrder,
            setHiddenColumns
        });
        if (hasSubColumnsList &&
            subColumnOrder &&
            defaultSubColumnsData &&
            setSubColumnOrder &&
            setHiddenSubColumns) {
            resetToDefaultHendler({
                orderedColumnIds: orderedSubColumnIds,
                columnsMap: subColumnsMap,
                requiredPredicate: requiredSubPredicate,
                needCompareByColumnName,
                defaultColumnsMap: defaultSubColumnsMap,
                setColumnOrder: setSubColumnOrder,
                setHiddenColumns: setHiddenSubColumns
            });
        }
    }, [
        orderedColumnIds,
        columnsMap,
        setColumnOrder,
        setHiddenColumns,
        needCompareByColumnName,
        requiredPredicate,
        defaultColumnsMap
    ]);
    return (React.createElement(StyledColumnSettings, null,
        React.createElement(React.Fragment, null,
            React.createElement(ResetButton, { onClick: handleResetToDefault }),
            React.createElement(Divider, null)),
        React.createElement(StyledColumnDndListWrap, null,
            React.createElement(ColumnSettingsDndList, { columns: columns, hiddenColumns: hiddenColumns, columnOrder: columnOrder, limit: limit, setColumnOrder: setColumnOrder, setHiddenColumns: setHiddenColumns, needUnselectedDown: needUnselectedDown, listTitle: hasSubColumnsList ? 'General Grid' : '', tooltipStyle: tooltipStyle }),
            hasSubColumnsList && setSubColumnOrder && setHiddenSubColumns ? (React.createElement(ColumnSettingsDndList, { columns: subColumns, hiddenColumns: hiddenSubColumns || [], columnOrder: subColumnOrder || [], limit: limit, setColumnOrder: setSubColumnOrder, setHiddenColumns: setHiddenSubColumns, needUnselectedDown: needUnselectedDown, listTitle: "Sub Grid", tooltipStyle: tooltipStyle })) : undefined)));
};
